import { Box, BoxProps as IBoxProps, styled } from "@mui/material";

export const NotFoundWrapper = styled(
  Box,
  {},
)<Partial<IBoxProps>>(({ theme }) => ({
  "&.not-found-container": {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      paddingRight: "3rem",
    },
    [theme.breakpoints.between("sm", "xl")]: {
      height: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      height: "50%",
    },
    ".error": {
      fontSize: "6rem",
      fontWeight: 700,
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem",
      },
      [theme.breakpoints.up("md")]: {
        fontSize: "5rem",
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: "7rem",
      },
    },
    ".error-text": {
      fontSize: "1rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: ".5rem",
      },
      [theme.breakpoints.up("md")]: {
        fontSize: "1rem",
      },
      [theme.breakpoints.up("xl")]: {
        fontSize: "1rem",
      },
    },
  },
}));
